import { Stack, styled } from "@mui/material";

const StyledContent = styled(Stack)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start", // Mudado de flex-end para flex-start para melhor controle do scroll
    // No gap between messages — each message's own footer/padding already gives it enough
    // breathing room; an extra gap here made consecutive messages read as too disconnected.
    rowGap: 0,
    flex: "1 1 0",
    minHeight: 0,
    minWidth: 0,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(9.75),
    // BottomArea is a normal flex sibling now (not absolutely positioned), so it reserves its own real
    // space below — this is just breathing room, not a stand-in for its height like paddingTop still is for the header.
    overflowY: "auto",
    overflowX: "hidden",
    scrollBehavior: "auto",
}));

export { StyledContent };
